export default __webpack_public_path__ + "static/media/Path 58.96f3120d.svg";